<template>
	<campaigns-tooltip-label class="omapi-campaign-settings__status" :icon="false">
		<template v-slot:label>
			<span class="omapi-campaign-settings__status-text">Status: {{ statusText }} <svg-calendar v-if="isScheduled"/></span>
			<a :href="publishLink" @click="maybeEditSchedule">
				{{ isScheduled ? 'Edit Schedule' : 'Set Schedule' }}
			</a>
		</template>
		<template v-slot:tooltip>
			<campaigns-rules-schedule v-if="isScheduled" :rules="scheduledRules"/>
			<span v-else>Determines whether this campaign can be displayed on this site.</span>
		</template>
		<select :value="statusText" @change="onChangeStatus" class="omapi-input omapi-input__select">
			<option value="Draft">
				Draft
			</option>
			<option value="Pending">
				Pending
			</option>
			<option value="Published">
				Published
			</option>
		</select>
		<common-transition-slide :active="'Pending' === statusText">
			<core-alert type="warn" icon="none">
				<div class="alert-message">
					<span class="omapi-campaign-settings__status-alert">🚀</span> Please verify your output settings, then change the status to Published to make it live on your site.
				</div>
			</core-alert>
		</common-transition-slide>

		<div v-if="debug">
			<div style="white-space: nowrap;">status: <code :style="`color: ${'active' === campaignStatus ? 'green' : 'red'}`">{{ campaignStatus }}</code></div>
			<div style="white-space: nowrap;">newStatus: <code :style="`color: ${'active' === newStatus ? 'green' : 'red'}`">{{ newStatus }}</code></div>
			<div style="white-space: nowrap;">enabled: <code :style="`color: ${settingEnabled ? 'green' : 'red'}`">{{ settingEnabled }}</code></div>
		</div>

	</campaigns-tooltip-label>
</template>

<script lang="js">
import { campaign } from '@/campaigns/mixins/campaign'
import { mapGetters } from 'vuex'
import { debug } from '@/utils'

export default  {
	mixins : [ campaign ],
	props  : {
		/**
		 * Campaign Id
		 */
		campaignId : {
			type : String,
		},
		/**
		 * Campaign Status
		 */
		newStatus : {
			type : String,
		},
		/**
		 * Campaign Status text
		 */
		statusText : {
			type : String,
		},
	},
	computed : {
		...mapGetters('campaigns', [ 'getCampaign' ]),
		/**
		 * Get the campaign object.
		 * @returns {Object} The campaign object.
		 */
		campaign () {
			return this.getCampaign(this.campaignId)
		},
		debug () {
			return debug.enabled('status')
		},
	},
	methods : {
		onChangeStatus (event) {
			this.$emit('updateStatus', event.target.value)
		},
	},
}
</script>
<style lang="scss">
	.omapi-campaign-settings {
		&__status {
			&-text {
				display: flex;
				justify-content: space-between;
				align-items: center;
				svg {
					margin-left: 4px;
				}
			}
			.setting-label-text {
				display: flex;
				justify-content: space-between;
				align-items: center;
				a {
					font-weight: normal !important;
					font-size: .9em;
				}
			}
			&-alert {
				font-size: 1.5em;
			}
		}
	}
</style>
